import { GetterTree } from 'vuex';
import { InquiryFormState, RootState } from '../types';

export const getters: GetterTree<InquiryFormState, RootState> = {
	getInquiryForm(state): InquiryForm | null {
		return state.inquiryForm;
	},

	getInquiryFormRequests(state): InquiryFormRequest[] {
		return state.inquiryFormRequests;
	},

	getSelectedInquiryFormRequest(state): InquiryFormRequest | null {
		return state.selectedInquiryFormRequest;
	},

	getInquiryFormFilters(state): InquiryFormFilters {
		return state.filters;
	},

	getCurrentPage(state): number {
		return state.currentPage;
	},

	getTotalPages(state): number {
		return state.totalPages;
	}
};
